export const stateinNigeria = [
  'Abia',
  'Adamawa',
  'Akwa Ibom',
  'Anambra',
  'Bauchi',
  'Bayelsa',
  'Benue',
  'Borno',
  'Cross River',
  'Delta',
  'Ebonyi',
  'Edo',
  'Ekiti',
  'Enugu',
  'FCT - Abuja',
  'Gombe',
  'Imo',
  'Jigawa',
  'Kaduna',
  'Kano',
  'Katsina',
  'Kebbi',
  'Kogi',
  'Kwara',
  'Lagos',
  'Nasarawa',
  'Niger',
  'Ogun',
  'Ondo',
  'Osun',
  'Oyo',
  'Plateau',
  'Rivers',
  'Sokoto',
  'Taraba',
  'Yobe',
  'Zamfara'
];

export const faqData = [
  {
    label: 'What is Madina?',
    content:
      'Madina is an exclusive network of marketing agents across Nigeria. It helps businesses solve marketing challenges and achieve growth and profitability.'
  },
  {
    label: 'How do I create an order on Madina?',
    content:
      'To create an order on Madina, log in to your account, browse products, add them to your cart, and proceed to checkout.'
  },
  {
    label: 'Having a delayed order. What do I do?',
    content: 'If your order is delayed, please contact our support team with your order ID for assistance.'
  },
  {
    label: 'I missed my delivery. What happens now?',
    content:
      'If you missed your delivery, our delivery team will attempt to contact you to reschedule. Alternatively, reach out to our support team.'
  },
  {
    label: 'How to change delivery information?',
    content:
      'To change delivery information, go to your account settings, update your address, and ensure it is saved before placing an order.'
  },
  {
    label: 'Having troubles adding products to cart?',
    content:
      'If you are having trouble adding products to your cart, try refreshing the page or clearing your browser cache. If the issue persists, contact support.'
  }
];

export const orderProduct = [
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#23467990',
    delivered: '07/08/2022',
    type: 'pending'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#23467340',
    delivered: '07/08/2022',
    type: 'pending'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#236673440',
    delivered: '07/08/2022',
    type: 'pending'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#236675540',
    delivered: '07/08/2022',
    type: 'pending'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#23464490',
    delivered: '07/08/2022',
    type: 'delivered'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#234612340',
    delivered: '07/08/2022',
    type: 'delivered'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#236451440',
    delivered: '07/08/2022',
    type: 'delivered'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#236612340',
    delivered: '07/08/2022',
    type: 'delivered'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#23400090',
    delivered: '07/08/2022',
    type: 'cancelled'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#23411140',
    delivered: '07/08/2022',
    type: 'cancelled'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#239999440',
    delivered: '07/08/2022',
    type: 'cancelled'
  },
  {
    url: 'https://images.unsplash.com/photo-1679599673055-62de1177335d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=772&q=80',
    title: 'Mama’s Pride',
    id: '#2364566740',
    delivered: '07/08/2022',
    type: 'cancelled'
  }
];
